import { render, staticRenderFns } from "./myshop.vue?vue&type=template&id=66f3c74b&"
import script from "./myshop.vue?vue&type=script&lang=js&"
export * from "./myshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports